export const StyledSpacer = (props: StyledSpacerProps) => {
	const { id, bleed, margin } = props;
	let type = 'medium';
	switch (margin) {
		case 'margin-1':
			type = 'vSmall';
			break;
		case 'margin-20':
			type = 'small';
			break;
		case 'margin-75':
			type = 'large';
			break;
		case 'margin-100':
			type = 'vLarge';
			break;
	}

	return (
		<Spacer id={id} type={type} bleed={bleed === 'on'} background={null} />
	);
};

interface StyledSpacerProps {
	id: string;
	bleed: string;
	margin: string;
}

export const Spacer = (props: SpacerProps) => {
	const { id, bleed, background, type } = props;
	const containerStyle: any = {
		background,
		clear: 'both',
	};

	const className = ['spacer'];

	switch (type) {
		case 'vSmall':
			className.push('v-small');
			break;
		case 'small':
			className.push('small');
			break;
		case 'large':
			className.push('large');
			break;
		case 'vLarge':
			className.push('v-large');
			break;
		default:
			className.push('medium');
			break;
	}

	if (bleed) {
		className.push('bleed');
	}

	return (
		<div id={id} className={className.join(' ')} style={containerStyle}>
			<br />
		</div>
	);
};

interface SpacerProps {
	id: string;
	bleed: boolean;
	background: string | null;
	type: string;
}
